export { default } from "./zaloguj";
